var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcquisition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("path", {
    d: "M16.24,23.5v-.817a3.478,3.478,0,0,0-6.951,0V23.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.832,
    cy: 15.547,
    rx: 1.999,
    ry: 1.931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.192,23.5v-.817a3.478,3.478,0,0,0-6.952,0V23.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.783,
    cy: 15.547,
    rx: 1.999,
    ry: 1.931
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.327.5h7.944a1.023,1.023,0,0,1,1.023,1.022V8.167a1.023,1.023,0,0,1-1.023,1.022H13.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "16.841 4.243 18.131 5.776 19.851 4.754 20.779 6.226"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.85,
    cy: 3.111,
    r: 2.611
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.434,14.652v-2.42h0l5.518-7.218.027-.034a1.695,1.695,0,0,0-2.692-2.059L8.276,6.789a1.127,1.127,0,0,1-.888.432H4.1A3.388,3.388,0,0,0,.706,10.609v3.956"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.373,
    y1: 9.189,
    x2: 21.373,
    y2: 11.051
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.85,
    y1: 9.511,
    x2: 4.85,
    y2: 11.051
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquisition);
export default __webpack_public_path__ + "static/media/acquisition.8e6a9426.svg";
export { ForwardRef as ReactComponent };